/**
 * Name: Burger
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Burger extends Collapsible {
  static settings = {
    control: '.js-burger-control',
    target: '.js-burger-target',
  };

  constructor (element, options = {}) {
    super(element, {
      ...Burger.settings,
      ...options,
    });
  }

  get isDisplayed () {
    return getComputedStyle(this.element).display !== 'none';
  }

  mount () {
    super.mount();
    this.target.classList.add('has-burger');
  }

  unmount () {
    super.unmount();
    this.target.classList.remove('has-burger');
  }
}
